import { DataBean } from "../../DataBean";


export class ProductTypeConstants extends DataBean {


    public async getHealthProductTypeConstants(args:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getHealthProductTypeConstants_Number", [args]);
    }


}